var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77922 5.0142C9.87323 4.83725 10.1268 4.83725 10.2208 5.0142L12.8294 9.92463L17.0572 17.8827C17.1456 18.0492 17.0249 18.25 16.8364 18.25H3.1636C2.97505 18.25 2.85437 18.0492 2.94283 17.8827L7.08182 10.0917L9.77922 5.0142Z",
    stroke: "#2B323B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14.5001H19.8229L18.3957 11.6456L18.1394 11.9051C17.65 12.4006 16.85 12.4006 16.3606 11.9051L16.1043 11.6456L15.8385 12.1772L15 10.5001L15.3452 9.80965L16.8028 6.89456C16.987 6.52603 17.513 6.52603 17.6972 6.89456L19.1548 9.80965L21.8882 15.2765C22.0544 15.609 21.8127 16.0001 21.441 16.0001C17.3882 16.0001 17.9182 16.3365 17.3882 15.2765L17 14.5001ZM16.8129 10.2284L17.25 9.35423L17.6871 10.2284L17.25 10.6709L16.8129 10.2284Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.12b91641b4f23ca9d33b7f5f5cf6fb84.svg";
export { ForwardRef as ReactComponent };